import QueryString from 'query-string';
import { FetchService } from '.';

export default class PromoService extends FetchService {
  constructor() {
    super();

    this.get = this.get.bind(this);
    this.post = this.post.bind(this);
    this.put = this.put.bind(this);
    this.delete = this.delete.bind(this);
  }

  get(query) {
    return this.Get('/promos?' + QueryString.stringify(query), { cache: 'no-store' });
  }

  post(data) {
    return this.Post('/promos', {
      body: JSON.stringify(data),
    });
  }

  put(data) {
    return this.Put('/promos', {
      body: JSON.stringify(data),
    });
  }

  delete(promo_id, venue_id) {
    return this.Post('/promos/delete', {
      body: JSON.stringify({ promo_id, venue_id }),
    });
  }
}
